/*******************************

NEW CODE

********************************/


$j(function($) {

    //auto expanding text areas
    $j('textarea').autosize();
    //On ready image loading
    $j("img.lazy").lazyload({
        threshold: 800,
        complete: equalHeightNow()
    });
});





/*************************************

	Equal Height Divs

***************************************/


/* Thanks to CSS Tricks for pointing out this bit of jQuery
http://css-tricks.com/equal-height-blocks-in-rows/
It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */



equalheight = function(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $j(container).each(function() {

        $el = $j(this);
        $j($el).height('auto');
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
};


function equalHeightNow() {
    equalheight('.masonry .product, .masonry .item');
}



$j(window).ready(function($) {
    equalHeightNow();
});

$j(window).load(function($) {
    equalHeightNow();
});

$j(window).scroll(function($) {
    equalHeightNow();
});

$j(window).resize(function($) {
    equalHeightNow();
});

/****
 * Cart
 ***/

/****
 * @context: input[id='updates_*']
 ****/
function displayUpdateButton() {
    var $this = $j(this);
    var itemWrapper = $this.closest(".itemWrapper");

    $j(".updateCartWrapper", itemWrapper).removeClass("hide");
}

/****
 * Items to consider
 ****/

/****
 * @return: iterable object
 ****/
function getRecentlyViewedItems() {

    return $j.cookies.get("recentlyViewedItems");
}

/****
 * @return: int
 ****/
function getRecentlyViewedItemsOverwriteIndex() {
    var index = $j.cookies.get("recentlyViewedItemsOverwriteIndex");

    if (index === null) {

        return 0;
    } else {

        return index;
    }
}

/****
 * @param: index, int
 ****/
function setRecentlyViewedItemsOverwriteIndex(index) {

    $j.cookies.set("recentlyViewedItemsOverwriteIndex", index);
}

/****
 * @param: index, int
 * @param: item, single object
 ****/
function setRecentlyViewItem(index, item) {
    var recentlyViewedItems = getRecentlyViewedItems();

    if (recentlyViewedItems === null) {
        recentlyViewedItems = [];
    }

    recentlyViewedItems[index] = item;

    $j.cookies.set("recentlyViewedItems", recentlyViewedItems);
}

/****
 * @param: itemName, string
 * @return: int if found, else false
 ****/
function getItemPositionInCookie(itemName) {
    var recentlyViewedItems = getRecentlyViewedItems();

    for (x in recentlyViewedItems) {
        if (recentlyViewedItems[x].name == itemName) {

            return x;
        }
    }

    return false;
}

/****
 * @param: product, single jQuery object
 * @return: single object
 ****/
function getProductData(product) {
    return {
        "image": $j(".productImage", product).attr("data-original"),
        "name": $j(".title", product).text(),
        "price": $j(".price", product).text(),
        "url": $j(".link", product).attr("href")
    };
}

/****
 * @param: item, single object
 ****/
function updateItemsToConsiderCookie(item) {
    var recentlyViewedItemsOverwriteIndex = getRecentlyViewedItemsOverwriteIndex();
    var recentlyViewedItems = getRecentlyViewedItems();
    var newIndex;

    if (recentlyViewedItems === null) {
        setRecentlyViewItem(0, item);

    } else if (recentlyViewedItems.length == 12) {
        newIndex = recentlyViewedItemsOverwriteIndex == 12 ? 0 : recentlyViewedItemsOverwriteIndex + 1;

        setRecentlyViewItem(recentlyViewedItemsOverwriteIndex, item);
        setRecentlyViewedItemsOverwriteIndex(newIndex);
    } else {
        setRecentlyViewItem(recentlyViewedItems.length, item);
    }
}

/****
 * @context: anchor
 ****/
function replaceItemsToConsiderCookie() {
    var itemPositionInCookie;
    var selectedProductData = getProductData($j(this).closest(".product"));

    itemPositionInCookie = getItemPositionInCookie(selectedProductData.name);

    if (itemPositionInCookie === false) {
        updateItemsToConsiderCookie(selectedProductData);
    }
}

/****
 * @param: newItems, iterable object
 ****/
function replaceItemsToConsider() {
    var items = $j(".itemList .product");
    var currentItem, currentItemImage;
    var recentlyViewedItems = getRecentlyViewedItems();

    if (recentlyViewedItems) {
        for (x in recentlyViewedItems) {
            currentItem = items.eq(x);
            currentItemImage = $j("img", currentItem);

            currentItemImage.attr("data-original", recentlyViewedItems[x].image);
            currentItemImage.attr("src", recentlyViewedItems[x].image);
            $j(".name", currentItem).text(recentlyViewedItems[x].name);
            $j(".price", currentItem).text(recentlyViewedItems[x].price);
            $j("a", currentItem).attr("href", recentlyViewedItems[x].url);
        }
    }
}

function toggleItemsToConsider() {
    var $this;
    var itemLists = $j(".itemList");

    $j.each(itemLists, function() {
        $this = $j(this);

        if ($this.is(":visible")) {
            $this.hide();
        } else {
            $this.show();
        }
    });
}

/****
 * @param: products, iterable jQuery object
 ****/
function attachProductsClickEvent(products) {
    $j.each(products, function() {
        $j.each($j("a", $j(this)), function() {
            $j(this).on("click", replaceItemsToConsiderCookie);
        });
    });
}





/********************************

Create alert for 10% off promo


**********************************/



function createAlert() {
    var wrapper = $j(document.createElement('div')).addClass('alert-box secondary text-center').attr('data-alert', 'true').attr('id', 'restrictions');
    var pulse = $j(document.createElement('div')).addClass('pulse');
    var msg1 = $j(document.createElement('span')).text('LIMITED TIME: ').addClass('red');
    var msg2 = $j(document.createElement('span')).text('10% off all orders. Use Coupon code: ');
    var msg3 = $j(document.createElement('span')).text('10PercentOffForAll ').addClass('orange extraHeavy');
    var msg4 = $j(document.createElement('span')).text('at checkout.');
    var msg5 = $j(document.createElement('a')).text(' Restrictions apply.').attr('href', '/pages/discount-restrictions').addClass('restrictions');

    var href = $j(document.createElement('a')).html('&times;').addClass("close").attr('href', '#').attr('id', 'closePromoAlert');

    pulse.append(msg1);
    pulse.append(msg2);
    pulse.append(msg3);
    pulse.append(msg4);
    pulse.append(msg5);
    wrapper.append(href);
    wrapper.append(pulse);
    $j('footer#main').prepend(wrapper);
}


$j(function() {

    if ($j.cookies.get('sua8gdhsa')) {
        createAlert();
    } else {

        var referrer = document.referrer.split('/')[2];
        var goodURLs = new Array("googleads.g.doubleclick.net", "otreva.com", "shopping.com", "shopzilla.com", "duckduckgo.com", "retailmenot.com", "ebay.com", "pronto.com", "nextag.com", "pricegrabber.com", "best-deal.com", "monstermarketplace.com", "shopwiki.com", "best-price.com", "dealtime.com", "shopwiki.com", "amazon.com", "calibex.com", "best-deal.com", "pricemachine.com", "compare99.com", "dealtime.com", "best-price.com", "sale-fire.com", "epinions.com", "thefind.com", "shoptrue.com", "pangora.com", "shopradius.com", "superfish.com", "calibex.com", "couponfollow.com", "answers.com");
        var newOptions = {
            expiresAt: new Date(2043, 1, 1)
        };

        $j.each(goodURLs, function(index, value) {
            if (value && referrer && referrer.indexOf(value) > 0) {
                $j.cookies.set('sua8gdhsa', "true", newOptions);
                createAlert();
            }
        });

    }


    $j('#closePromoAlert').on('click', function() {
        $j.cookies.del('sua8gdhsa');
    });


});